import { render, staticRenderFns } from "./CampaignDropdown.vue?vue&type=template&id=48b22bf8&scoped=true&"
import script from "./CampaignDropdown.vue?vue&type=script&lang=js&"
export * from "./CampaignDropdown.vue?vue&type=script&lang=js&"
import style0 from "./CampaignDropdown.vue?vue&type=style&index=0&id=48b22bf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b22bf8",
  null
  
)

export default component.exports